<template>
    <div class="container">
        <section id="catalog-intro" class="section catalog-intro">
            <h1 class="title">Aquí no hay promesas, hay resultados. Descubre nuestras creaciones.</h1>
            <img src="../assets/CatalogSelk.svg" alt="Catálogo de soluciones de Selk" />
        </section>

        <section id="catalog-items" class="section" aria-labelledby="catalog-items-heading">
            <h2 id="catalog-items-heading" class="catalog-heading">Lo que entregamos</h2>

            <ul class="catalog-grid">
                <li v-for="item in items" :key="item.id" class="catalog-card">
                    <div class="catalog-media">
                        <picture>
                            <img :src="item.image" :alt="item.imageAlt" loading="lazy" decoding="async" />
                        </picture>
                    </div>

                    <div class="catalog-body">
                        <h3 class="catalog-name">{{ item.name }}</h3>
                        <ul class="catalog-points">
                            <li v-for="point in item.points" :key="point">{{ point }}</li>
                        </ul>
                        <router-link :to="item.to" class="catalog-cta">{{ item.cta }} →</router-link>
                    </div>
                </li>
            </ul>
        </section>
    </div>
</template>

<script>
export default {
    name: 'CatalogPage',
    data() {
        return {
            items: [
                {
                    id: 'impresion3d',
                    name: 'Diseño y fabricación 3D',
                    points: [
                        'Piezas reales listas para usar',
                        'Prototipos funcionales antes de producir',
                        'Alta precisión y detalle',
                        'Impresión 3D bajo demanda',
                    ],
                    cta: 'Ver impresión 3D',
                    to: '/print3d',
                    image: require('../assets/Catalog3D.svg'),
                    imageAlt: 'Pieza fabricada mediante impresión 3D',
                },
                {
                    id: 'automatizacion',
                    name: 'Automatización de procesos',
                    points: [
                        'Centraliza y ordena la información de tu negocio',
                        'Automatiza tareas repetitivas y ahorra tiempo',
                        'Optimiza tu producción y reduce costos',
                        'Conecta todas tus herramientas en un solo lugar',
                    ],
                    cta: 'Ver el área',
                    to: { path: '/services', hash: '#area-automatizacion' },
                    image: require('../assets/CatalogAppPage.png'),
                    imageAlt: 'Aplicativo web de gestión y automatización',
                },
                {
                    id: 'aplicativos',
                    name: 'Aplicativos y sitios web',
                    points: [
                        'Diseño moderno que refleja tu marca',
                        'Se ve perfecto también en el celular',
                        'Conectado con tus redes sociales',
                        'Tu negocio visible para nuevos clientes',
                    ],
                    cta: 'Ver el área',
                    to: { path: '/services', hash: '#area-aplicativos' },
                    image: require('../assets/webPageDesing.svg'),
                    imageAlt: 'Sitio web responsivo diseñado a medida',
                },
            ],
        };
    },
}
</script>

<style scoped>
/* ---------- Intro ---------- */
.catalog-intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.catalog-intro h1 {
    margin: var(--space-md) 0 var(--space-md) 0;
}

.catalog-intro img {
    width: 100%;
    max-width: 760px;
    height: auto;
}

/* ---------- Grilla de resultados ---------- */
.catalog-heading {
    font-family: var(--font-subtitle);
    font-weight: 700;
    font-size: 40px;
    line-height: 1.1;
    color: var(--color-title);
    margin: 0 0 var(--space-lg) 0;
}

.catalog-grid {
    list-style: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: var(--space-md);
}

.catalog-card {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--color-border);
    border-radius: 16px;
    overflow: hidden;
    background-color: var(--color-white);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.catalog-card:hover {
    transform: translateY(-4px);
    box-shadow: 0px 14px 30px -12px rgba(82, 109, 130, 0.45);
}

/* Se conserva el degradado de marca del catálogo anterior, ahora contenido
   dentro de la tarjeta en lugar de ocupar el ancho completo de la pantalla. */
.catalog-media picture {
    display: block;
    aspect-ratio: 4 / 3;
    background: linear-gradient(180deg, #344F5C 0%, #45B3BC 100%);
    overflow: hidden;
}

.catalog-media img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    padding: var(--space-sm);
    box-sizing: border-box;
}

.catalog-body {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: var(--space-md);
}

.catalog-name {
    font-family: var(--font-subtitle);
    font-weight: 700;
    font-size: 24px;
    line-height: 1.2;
    color: var(--color-title);
    margin: 0 0 var(--space-sm) 0;
}

.catalog-points {
    list-style: none;
    margin: 0 0 var(--space-md) 0;
    padding: 0;
    flex: 1;
}

.catalog-points li {
    font-family: var(--font-body);
    font-size: 17px;
    line-height: 1.4;
    color: var(--color-text);
    padding-left: 1.6rem;
    position: relative;
    margin-bottom: var(--space-xs);
}

.catalog-points li::before {
    content: '✔';
    position: absolute;
    left: 0;
    top: 0.15em;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: var(--color-accent);
    color: var(--color-white);
    font-size: 10px;
}

.catalog-cta {
    align-self: flex-start;
    font-family: var(--font-body);
    font-size: 17px;
    color: var(--color-action);
    text-decoration: none;
    border-bottom: 2px solid transparent;
    transition: color 0.2s ease, border-color 0.2s ease;
}

.catalog-cta:hover {
    color: var(--color-brand);
    border-bottom-color: var(--color-brand);
}

@media (max-width: 1024px) {
    .catalog-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 800px) {
    .catalog-heading { font-size: 1.75rem; text-align: center; margin-bottom: var(--space-md); }
    .catalog-grid { grid-template-columns: 1fr; }
    .catalog-intro img {
        content: url(../assets/CatalogSelk_Movile.svg);
    }
}
</style>
